import React from "react";
import { getGeneralError } from "./util";
import { FormikErrors } from "formik";

type GeneralErrorProps<T> = {
  errors: FormikErrors<T>;
};

export default function GeneralError<T>({ errors }: GeneralErrorProps<T>) {
  const error = getGeneralError<T>(errors);
  return error ? <div className="alert-error">{error}</div> : null;
}
